import { useApolloClient } from "@apollo/client";
import Tabs, { TabItem } from "@mostrans/web-components/components/base/Tabs";
import {
	Button,
	Card,
	CardActionArea,
	CardMedia,
	Divider,
	Grid,
	Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import { getDetailCandidateOpportunity } from "../../../../graphql/query";
import { globalLoadingScreenAtom } from "../../../../shared/globalStates";
import { toastError } from "../../../../shared/helpers";
import CandidateResult from "../CandidateResult";
import CfitResult from "../CfitResult";
import PapikostikResult from "../PapikostikResult";
import PreAssesmentAdmin from "../PreAssesmentAdmin";
import ProfileOverview from "../ProfileOverview";
import ResumeCandidate from "../ResumeCandidate";

function ModalCandidate(props) {
	const [open, setOpen] = useState(false);
	const handleClose = () => setOpen(false);
	const [tabProfile, setTabProfile] = useState(true);
	const [tabResume, setTabResume] = useState(false);
	const [tabCfit, setTabCfit] = useState(false);
	const [tabPapikostik, setTabPapikostik] = useState(false);
	const [tabPreAssesment, setTabPreAssesment] = useState(false);
	const [tabCandidateResult, setTabCandidateResult] = useState(false)
	const { candidateID, fetchCandidateOpportunityByID, opportunityID } = props;
	const [candidateDetail, setCandidateDetail] = useState([]);
	const client = useApolloClient();
	const setIsLoading = useSetRecoilState(globalLoadingScreenAtom)

	// console.log(opportunityID)

	const handleTabProfile = () => {
		setTabProfile(true);
		setTabResume(false);
		setTabCfit(false);
		setTabPapikostik(false);
		setTabCandidateResult(false)
		setTabPreAssesment(false);
	};
	const handleTabResume = () => {
		setTabResume(true);
		setTabProfile(false);
		setTabCfit(false);
		setTabPapikostik(false);
		setTabCandidateResult(false)
		setTabPreAssesment(false);
	};
	const handleTabCFIT = () => {
		setTabResume(false);
		setTabProfile(false);
		setTabCfit(true);
		setTabPapikostik(false);
		setTabCandidateResult(false)
		setTabPreAssesment(false);
	};

	const handleTabPapikostik = () => {
		setTabResume(false);
		setTabProfile(false);
		setTabCfit(false);
		setTabPapikostik(true);
		setTabCandidateResult(false)
		setTabPreAssesment(false);
	};

	const handleTabPreAssesment = () => {
		setTabResume(false);
		setTabProfile(false);
		setTabCfit(false);
		setTabPapikostik(false);
		setTabCandidateResult(false)
		setTabPreAssesment(true);
	};

	const handleTabCandidateResult = () => {
		setTabResume(false);
		setTabProfile(false);
		setTabCfit(false);
		setTabPapikostik(false);
		setTabPreAssesment(false);
		setTabCandidateResult(true)
	}

	const openCandidateDetail = async (candidateID, opportunityID) => {
		try {
			setIsLoading(true)
			await getDetailCandidateOpportunity(client, candidateID, parseInt(opportunityID)).then((candidate) =>
				setCandidateDetail(candidate)
			);
			// 	await GetCandidateByID(client, candidateID, opportunityID).then((candidate) =>
			// 	setCandidateDetail(candidate)
			// );
		} catch (error) {
			toastError(error)
		} finally {
			setOpen(true);
			setIsLoading(false)
		}
	};

	return (
		<React.Fragment>
			<Button size="small" style={{ zIndex: 0 }} onClick={() => openCandidateDetail(candidateID, opportunityID)}>
				View Full Profile
			</Button>
			<Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="xl" style={{ zIndex: '90' }}>
				<Grid container>
					<Grid item>
						<DialogTitle>Candidate Details</DialogTitle>
					</Grid>
				</Grid>
				<DialogContent>
					<Grid>
						<div className="form-row">
							<div className="col-md-3">
								<Card sx={{ maxWidth: 345 }}>
									<CardActionArea>
										<CardMedia
											component="img"
											height="350"
											image={candidateDetail?.link_photo}
										/>
										{/* <CardContent>
											<Typography gutterBottom variant="h5" component="div">
												{candidateDetail.full_name}
											</Typography>
											<Typography variant="body2" color="text.secondary">
												Email : {candidateDetail?.email} <br /> Telp :{" "}
												{candidateDetail?.phone_number}
											</Typography>
										</CardContent> */}
									</CardActionArea>
									<div className="p-1">
										<Typography color="primary" gutterBottom variant="h6" component="div">
											{candidateDetail.full_name}
										</Typography>
										<Typography variant="body2" color="text.secondary">
											Email  : {candidateDetail?.email}
										</Typography>
										<Typography variant="body2" color="text.secondary">
											Telp    : {candidateDetail?.phone_number}
										</Typography>
									</div>
									</Card>
									<div className="p-1">
										<Typography variant="body" color="text.secondary">
											Apply Date:
										</Typography>
										<Typography color="primary" gutterBottom variant="h6" component="div">
											{candidateDetail?.Opportunity?.created_date}
										</Typography>
								</div>
							</div>
							<div className="col-md-9" style={{ paddingLeft: "20px" }}>
								<Tabs>
									<TabItem
										style={{ fontSize: 14 }}
										current={tabProfile}
										onClick={handleTabProfile}
									>
										Profile Overview
									</TabItem>
									<TabItem
										style={{ fontSize: 14 }}
										current={tabResume}
										onClick={handleTabResume}
									>
										Resume
									</TabItem>
									<TabItem
										style={{ fontSize: 14 }}
										current={tabPreAssesment}
										onClick={handleTabPreAssesment}
									>
										Pre Assesment
									</TabItem>
									<TabItem
										style={{ fontSize: 14 }}
										current={tabCfit}
										onClick={handleTabCFIT}
									>
										CFIT Result
									</TabItem>
									<TabItem
										style={{ fontSize: 14 }}
										current={tabPapikostik}
										onClick={handleTabPapikostik}
									>
										Papikostik Result
									</TabItem>
									<TabItem
										style={{ fontSize: 14 }}
										current={tabCandidateResult}
										onClick={handleTabCandidateResult}
									>
										Candidate Result
									</TabItem>
								</Tabs>
								<Divider />
								{tabProfile && (
									<ProfileOverview
										dataCandidateByID={candidateDetail}
										handleCloseModalCandidate={handleClose}
										fetchCandidateOpportunityByID={fetchCandidateOpportunityByID} />
								)}
								{tabResume && (
									<ResumeCandidate dataCandidateByID={candidateDetail} />
								)}
								{tabCfit && (
									<CfitResult dataCandidateByID={candidateDetail} />
								)}
								{tabPapikostik && (
									<PapikostikResult dataCandidateByID={candidateDetail} />
								)}
								{tabPreAssesment && (
									<PreAssesmentAdmin dataCandidateByID={candidateDetail} />
								)}
								{tabCandidateResult && (
									<CandidateResult dataCandidateByID={candidateDetail} />
								)}
							</div>
						</div>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} variant="contained" color="error">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
}

export default ModalCandidate;
